export const numberHelpers = {
  prettyPercent: (number: number) => {
    if (isNaN(number)) return '0%'
    return `${Math.round(number * 100)}%`
  },

  prettyFloat: (number = 0): number | string => {
    if (!number) return 0
    return number % 1 === 0 ? number : number.toFixed(2)
  },

  prettyFloatWithCommas: (number = 0) => {
    return numberHelpers
      .prettyFloat(number)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  },

  revenuePercent: (income: number, expense: number) => {
    const revenue = income - expense
    const formattedRevenue = numberHelpers.prettyFloatWithCommas(revenue)
    const formattedDiff = numberHelpers.prettyPercent(revenue / expense)
    const operator = revenue === 0 ? '' : revenue > 0 ? '+' : '-'

    return `${operator}${formattedRevenue} (${formattedDiff})`
  },

  revenueAmount: (income: number, expense: number) => {
    const revenue = income - expense
    const formattedRevenue = numberHelpers.prettyFloatWithCommas(revenue)
    const operator = revenue === 0 ? '' : revenue > 0 ? '+' : '-'

    return `${operator} $${formattedRevenue}`
  },

  checkValidStringDollarAmount: (string: string) => {
    // checks a string, ex: '12.12' to check it's the proper dollar format
    // strings containing the $ will not pass, ex '$12.12' will not pass this check.
    // String must only contain numbers OR numbers with a decimal place ex: '12.12' or '12' will both pass
    // returns a boolean
    return /^\d*\.?\d{0,2}$/.test(string)
  },
}

export const roundDecimals = (decimals: number) => (value: number | null) => {
  if (!value) return null
  return Number(Math.round(+(value + 'e' + decimals)) + 'e-' + decimals)
}

const numberUtils = {
  numberHelpers,
  roundDecimals,
}

export default numberUtils
